import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {TableComponent} from '../../../../../components/table/table.component';
import {FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  DateTimeSelectorComponent
} from '../../../../../components/form-inputs/date-time-selector/date-time-selector.component';
import {FormGroupComponent} from '../../../../../components/form-inputs/form-group/form-group.component';
import {Backend, PERMISSION} from '@generated-backend-types';
import {StrictFormGroup} from '@browsepedia/ng-forms';
import {FormSubmitService} from '../../../../../services/form-submit.service';
import {DateTime} from 'luxon';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {Observable} from 'rxjs';
import {
  TimeTrackingEmployeeYearlyVacationDaysService
} from '../../../../../services/api/time-tracking/time-tracking-employee-yearly-vacation-days.service';
import {TimeTrackingConfigListBaseComponent} from '../time-tracking-config-list-base.component';
import TimeTrackingEmployeeYearlyVacationDaysData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeYearlyVacationDaysData;
import TimeTrackingEmployeeYearlyVacationDays = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeYearlyVacationDays;


interface YearlyVacationDaysFormData {
  valid_from: string;
  days: number | null;
}

@Component({
  selector: 'app-authenticated-time-tracking-employees-edit-yearly-vacation-days',
  templateUrl: './yearly-vacation-days.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslatePipe,
    TableComponent,
    FormsModule,
    ReactiveFormsModule,
    DateTimeSelectorComponent,
    FormGroupComponent,
    ModalModule,
  ],
  providers: [BsModalService],
})
export class YearlyVacationDaysComponent extends TimeTrackingConfigListBaseComponent {
  protected readonly translationPrefix = 'authenticated.time_tracking.employees.edit.vacation_days';
  public form: StrictFormGroup<YearlyVacationDaysFormData> = this.fb.group({
    valid_from: this.fb.control('', [Validators.required]),
    days: this.fb.control(null, [Validators.required]),
  });

  public constructor(
    private readonly fb: NonNullableFormBuilder,
    formSubmitService: FormSubmitService,
    private readonly yearlyVacationDaysService: TimeTrackingEmployeeYearlyVacationDaysService,
    translate: TranslateService,
    cdr: ChangeDetectorRef,
    bsModalService: BsModalService,
  ) {
    super(formSubmitService, yearlyVacationDaysService, translate, cdr, bsModalService);
  }

  protected resetForm() {
    this.form.patchValue({
      days: null,
      valid_from: '',
    });
  }

  protected submitForm(): Observable<unknown> {
    return this.formSubmitService.submit<TimeTrackingEmployeeYearlyVacationDays, TimeTrackingEmployeeYearlyVacationDaysData, TimeTrackingEmployeeYearlyVacationDaysService, YearlyVacationDaysFormData>({
      form: this.form,
      service: this.yearlyVacationDaysService,
      createPermission: PERMISSION.TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEYEARLYVACATIONDAYS_CREATE_ALL,
      createSuccessMessage: this.translate.instant('authenticated.time_tracking.employees.edit.vacation_days.create.success'),
      createErrorMessage: this.translate.instant('authenticated.time_tracking.employees.edit.vacation_days.create.error'),
      dataTransformer: data => {
        return {
          time_tracking_employee_id: this.employee.id,
          // Non-null: FormSubmitService aborts on invalid forms, and days is Validators.required.
          days: data.days!,
          valid_from: DateTime.fromISO((data.valid_from ?? '')).toFormat('yyyy-MM-dd'),
        }
      },
    });
  }
}
